"use client";

import { useSendOtp } from "@repo/lib/hooks/account";
import { Button, ErrorMessage, Input, LoadingDots } from "@repo/ui";
import { useTranslations } from "next-intl";
const SendOtpForm = ({
  formValues,
  formErrors,
  setFormErrors,
  handleValidation,
  setShowVerifyOTP
}) => {
  const {
    isPending,
    handleSendOtp
  } = useSendOtp(formValues, setFormErrors, setShowVerifyOTP);
  const t = useTranslations("Common");
  return <form onSubmit={handleSendOtp} data-sentry-component="SendOtpForm" data-sentry-source-file="SendOtpForm.jsx">
      <Input type="text" label={t("Email")} placeholder={t("Eg_You_@_Example_com")} name="email" value={formValues?.email} onChange={handleValidation} data-sentry-element="Input" data-sentry-source-file="SendOtpForm.jsx" />
      <ErrorMessage message={formErrors?.email} data-sentry-element="ErrorMessage" data-sentry-source-file="SendOtpForm.jsx" />
      <Button size="md" type="submit" className="mt-6 w-full" variant="primary" disabled={isPending} data-sentry-element="Button" data-sentry-source-file="SendOtpForm.jsx">
        {isPending ? <LoadingDots className="bg-white" /> : t("Get_OTP")}
      </Button>
    </form>;
};
export default SendOtpForm;